import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import commentIcon from "../../../../assets/svg/comment.svg";
import vector71Icon from "../../../../assets/svg/Vector 71.svg";
import viewIcon from "../../../../assets/svg/view.svg";
import {
  Form,
  Image,
  Grid,
  Table,
  Icon,
  Button,
  Comment,
  CommentGroup,
  CommentMetadata,
  GridRow,
  GridColumn,
  Segment,
  Divider,
  Header,
  Modal,
  ModalHeader,
  ModalContent,
  ModalActions,
  List,
  Message,
  TableRow,
  Label,
  Popup,
} from "semantic-ui-react";
import { useFormik } from "formik";
import { Socialform, Form as FormApi, AuditLog } from "../../../../api";
const auditLogController = new AuditLog();
import { useAuth } from "../../../../hooks";
import { PERIODS, units_12 } from "../../../../utils";
import {
  formatDateView,
  formatDateHourCompleted,
} from "../../../../utils/formatDate";
import { BasicModal } from "../../../Shared";
import { initialValues, validationSchema } from "./SocialForm.form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { decrypt, encrypt } from "../../../../utils/cryptoUtils";
import "./SocialForm.scss";
//import { convertPeriodsEngToEsp } from "../../../../utils/converts";
//import { socialCodes } from "../../../../utils/codes";
import { useLanguage } from "../../../../contexts";
import { determineSocialUnits } from "../../../../utils/dataAndFormulas/socialForms";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importa el CSS de react-toastify
import { isAdmin, isEditor, isReviewer, isMaster } from "../../../../utils/checkPermission";

const socialFormController = new Socialform();

export function SocialForm(props) {
  const {
    onClose,
    onReload,
    socialForm,
    siteSelected,
    year,
    period,
    configFormData,
    unitsRecorded,
  } = props;
  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [listPeriods, setListPeriods] = useState([]);
  const [yearComplete, setYearComplete] = useState(false);
  const [newFiles, setNewFiles] = useState({});
  const [unitEditEnabled, setUnitEditEnabled] = useState(false);

  // Lector de documentos social
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceResults, setInvoiceResults] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const invoiceInputRef = useRef(null);

  const { user } = useAuth();

  // Verificar si el usuario puede editar unidades (admin o master)
  const canEditUnits = isAdmin(user.role) || isMaster(user.role);

  const location = useLocation();
  //const { siteSelected } = location.state || {};

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  if (!siteSelected) {
    // // Manejo de caso donde no hay datos en state (por ejemplo, acceso directo a la URL)
    // return <div>No se encontraron detalles de producto.</div>;
  }

  const navigate = useNavigate();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateSocial = (data, name) => {
    setFieldName(name);
    setTitleModal(`${t("comments")} ${data}`);
    onOpenCloseModal();
  };

  function setNestedError(obj, path, value) {
    const keys = path.split("."); // ["natural_gas", "unit"]
    let current = obj;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = value; // asigna el mensaje de error al último nivel
      } else {
        if (!current[key]) current[key] = {}; // crea objeto si no existe
        current = current[key]; // baja al siguiente nivel
      }
    });
  }

  
  // Helper function to get approval status styling
  const getApprovalStatusStyle = (approvalStatus, isDisabled = false) => ({
    backgroundColor:
      approvalStatus === "approved" ? "#d4edda" :
      approvalStatus === "rejected" ? "#f8d7da" :
      approvalStatus === "pending" ? "#fff3cd" : "white",
    color:
      approvalStatus === "approved" ? "#155724" :
      approvalStatus === "rejected" ? "#721c24" :
      approvalStatus === "pending" ? "#856404" : "black",
    fontWeight: "bold",
    opacity: isDisabled ? 0.9 : 1
  });

  // Helper function para limpiar el valor 0 cuando se hace focus en el campo
  const handleFocusNumberInput = (e) => {
    const value = e.target.value;
    if (value === "0" || value === 0) {
      e.target.value = "";
    }
  };

  const formik = useFormik({
    initialValues: initialValues(socialForm, period, year, unitsRecorded),
    // validationSchema: validationSchema(),

    validate: (values) => {
      const errors = {};
      try {
        validationSchema().validateSync(values, { abortEarly: false });
      } catch (err) {
        if (err.inner && err.inner.length > 0) {
          err.inner.forEach((e) => {
            errors[e.path] = e.message;
            setNestedError(errors, e.path, e.message);
            formik.setFieldTouched(e.path, true, false);
          });

          // 🔹 Mostrar toast resumido
          const fields = err.inner
            .map((e) => {
              if (e.path.includes(".unit"))
                return `${t("unit")} (${t(e.path.split(".")[0])})`;
              if (e.path.includes(".value"))
                return `${t("value")} (${t(e.path.split(".")[0])})`;
              return t(e.path);
            })
            .join(", ");
          toast.error(`Faltan completar datos: ${t(fields)}`);

          // 🔹 Scroll automático al primer error
          // 🔹 Scroll automático al primer error
          const firstErrorPath = err.inner[0]?.path;
          if (firstErrorPath) {
            const fieldId = firstErrorPath.replace(/\./g, "_");
            let fieldEl =
              document.getElementById(fieldId) ||
              document.querySelector(`[name="${firstErrorPath}"]`);

            if (!fieldEl) {
              fieldEl = Array.from(
                document.querySelectorAll("input, select, textarea")
              ).find(
                (el) =>
                  el.name?.includes(firstErrorPath) || el.id?.includes(fieldId)
              );
            }

            if (fieldEl) {
              // Buscar el contenedor con scroll
              let scrollContainer = fieldEl.parentElement;
              while (
                scrollContainer &&
                scrollContainer !== document.body &&
                scrollContainer.scrollHeight <= scrollContainer.clientHeight
              ) {
                scrollContainer = scrollContainer.parentElement;
              }

              // Calcular posición
              const rect = fieldEl.getBoundingClientRect();
              const offset = 150;

              if (scrollContainer && scrollContainer !== document.body) {
                const containerRect = scrollContainer.getBoundingClientRect();
                const scrollTopTarget =
                  scrollContainer.scrollTop +
                  (rect.top - containerRect.top) -
                  offset;
                scrollContainer.scrollTo({
                  top: scrollTopTarget,
                  behavior: "smooth",
                });
              } else {
                window.scrollTo({
                  top: rect.top + window.scrollY - offset,
                  behavior: "smooth",
                });
              }

              fieldEl.focus({ preventScroll: true });
            } else {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        }
      }
      return errors;
    },

    validateOnChange: false,
    onSubmit: async (formValue) => {

      try {
        if (!socialForm) {
          formValue.creator_user = user._id;
          formValue.date = new Date();
          if (user?.site) {
            formValue.site = user.site;
          } else {
            if (siteSelected) {
              formValue.site = siteSelected;
            }
            // } else {
            //   // Desencriptar los datos recibidos
            //   if (!siteForm) {
            //     const siteData = decrypt(siteSelected);
            //     formValue.site = siteData;
            //   }
            // }
          }
          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const finalData = removeNullValues(formValue);
          // console.log(formValue);
          const response = await socialFormController.createSocialForm(
            accessToken,
            formValue
          );

          if (response.code && response.code === 200) {
            toast.success("Formulario guardado correctamente!.");
          }
          //console.log(formValue);
        } else {
          // Detectar cambios de unidad para auditoría (solo admin/master)
          if (isAdmin(user.role) || isMaster(user.role)) {
            const unitChanges = [];
            for (const fieldName in formValue) {
              if (formValue[fieldName]?.unit !== undefined && socialForm[fieldName]?.unit !== undefined) {
                if (formValue[fieldName].unit !== socialForm[fieldName].unit) {
                  unitChanges.push({
                    field: fieldName,
                    oldUnit: socialForm[fieldName].unit,
                    newUnit: formValue[fieldName].unit,
                    oldValue: socialForm[fieldName].value,
                    newValue: formValue[fieldName].value,
                  });
                }
              }
            }

            // Registrar cambios de unidad en auditoría
            for (const change of unitChanges) {
              try {
                await auditLogController.createAuditLog(accessToken, {
                  documentId: socialForm._id,
                  documentType: "social",
                  field: change.field,
                  oldValue: { value: change.oldValue, unit: change.oldUnit },
                  newValue: { value: change.newValue, unit: change.newUnit },
                  changeType: "unit_change",
                  changedBy: user._id,
                  site: socialForm.site?._id || socialForm.site,
                  company: socialForm.company,
                  year: socialForm.year,
                  period: socialForm.period,
                });
              } catch (auditError) {
                console.error("Error registrando auditoría:", auditError);
              }
            }

            if (unitChanges.length > 0) {
              toast.info(`${unitChanges.length} cambio(s) de unidad registrado(s) en auditoría`);
            }
          }

          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const finalData = removeNullValues(formValue);
          const response2 = await socialFormController.updateSocialForm(
            accessToken,
            socialForm._id,
            finalData
          );

          if (response2.code && response2.code === 200) {
            toast.success("Formulario guardado correctamente!.");
          }
        }

        // Retrasar el cierre del modal o el reload para dar tiempo a que la tostada se vea
        setTimeout(() => {
          onReload();
          if (onClose) {
            onClose();
          } else {
            // Después de guardar exitosamente, navegamos hacia atrás
            goBack();
          }
        }, 1000);
      } catch (error) {
        console.error(error);
      }
    },
  });

  const uploadFiles = async (filesToUpload, formValue, field) => {
    const formData = new FormData();
    Array.from(filesToUpload).forEach((file) => {
      formData.append("files", file);
    });

    // Luego de preparar los datos, puedes hacer la solicitud POST
    if (filesToUpload.length === 0) {
      //console.log("no hay archivos");
      //setErrorMessage("Por favor, selecciona al menos un archivo.");
      return;
    }

    try {
      // Realizar la solicitud POST al backend
      const response = await socialFormController.uploadFileApi(
        accessToken,
        formData
      );
      if (response.code && response.code === 200) {
        return response.files;
      }
      return [];
    } catch (error) {
      //error
    }
  };

  function removeNullValues(obj) {
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key].hasOwnProperty("value")) {
        if (obj[key].value === "" || obj[key].value === null) {
          delete obj[key];
        }
      }
    }
    return obj;
  }

  const goBack = () => {
    navigate(`/admin/data/siteforms`, {
      state: { siteSelected: siteSelected },
    });
  };

  const processInvoiceFiles = async (files) => {
    if (!files || files.length === 0) return;
    setInvoiceLoading(true);
    try {
      const formData = new FormData();
      files.forEach(f => formData.append("files", f));
      const result = await socialFormController.readDocument(accessToken, formData);
      if (result.code === 200) {
        setInvoiceResults(result.results);
        setShowUploadModal(false);
        setShowInvoiceModal(true);
      } else {
        toast.error(result.msg || t("could_not_read_document"));
      }
    } catch (err) {
      toast.error(err?.msg || err?.message || t("error_processing_invoice"));
    } finally {
      setInvoiceLoading(false);
    }
  };

  const handleInvoiceFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    e.target.value = "";
    await processInvoiceFiles(files);
  };

  const handleApplyInvoiceData = (result) => {
    if (!result) return;
    if (result.period) formik.setFieldValue("period", result.period);
    if (result.year) formik.setFieldValue("year", result.year);
    setShowInvoiceModal(false);
    toast.success(t("invoice_data_applied"));
  };

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  useEffect(() => {
    (async () => {
      try {
        const response =
          await socialFormController.getPeriodsSocialFormsBySiteAndYear(
            accessToken,
            siteSelected,
            formik.values.year
          );
        const periods = PERIODS.map((item) => item);
        const availablePeriods = periods
          .filter((period) => !response.periods.includes(period))
          .map((period) => period);

        setListPeriods(availablePeriods);

        // Detectar si todos los meses del año están completos
        if (availablePeriods.length === 0) {
          setYearComplete(true);
        } else {
          setYearComplete(false);
        }
      } catch (error) {
        console.error(error);
        setListPeriods([]);
        setYearComplete(false);
      }
    })();
  }, [formik.values.year]);

  function findActiveFieldByName(nameToFind) {
    if (configFormData && configFormData.fields) {
      return configFormData.fields.some(
        (field) => field.name === nameToFind && field.active
      );
    }
    return true;
  }

  return (
    <Form
      className="social-form"
      onSubmit={(e) => {
        formik.handleSubmit(e);
      }}
    >
      {socialForm ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="calendar alternate outline" style={{ margin: 0 }} />
            {socialForm.date ? formatDateView(socialForm.date) : "-"}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="user outline" style={{ margin: 0 }} />
            {socialForm.creator_user
              ? socialForm.creator_user.lastname
                ? socialForm.creator_user.lastname + " " + socialForm.creator_user.firstname
                : socialForm.creator_user.email
              : "-"}
          </span>
        </div>
      ) : null}
      {!socialForm ? (
        <>
          <Grid columns={2} divided>
            <GridRow style={{ display: "flex", gap: "20px" }}>
              {/* Año */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("year")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={years.map((year) => ({
                        key: year,
                        text: year,
                        value: year,
                      }))}
                      selection
                      onChange={(_, data) =>
                        formik.setFieldValue("year", data.value)
                      }
                      value={formik.values.year}
                      error={!!formik.errors.year && !!formik.touched.year}
                      style={{ flex: 1 }}
                      name="year"
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.year && formik.errors.year}
                  </div>
                </div>
              </GridColumn>

              {/* Periodo */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("period")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={listPeriods.map((period) => ({
                        key: period,
                        text: t(period),
                        value: period,
                      }))}
                      selection
                      value={formik.values.period}
                      onChange={(_, data) => {
                        // Actualiza el valor
                        formik.setFieldValue("period", data.value);
                        // Marca el campo como tocado (opcional)
                        formik.setFieldTouched("period", true, false);
                        // Borra el error si hay uno
                        formik.setFieldError("period", undefined);
                      }}
                      error={!!formik.errors.period && !!formik.touched.period}
                      style={{ flex: 1 }}
                      name="period"
                      disabled={yearComplete}
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.period && formik.errors.period}
                  </div>
                </div>
              </GridColumn>
            </GridRow>
          </Grid>
          {/* Mensaje de advertencia cuando el año está completo */}
          {yearComplete && !socialForm && (
            <div
              style={{
                position: "fixed",
                top: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "90%",
                maxWidth: "800px",
                zIndex: 99999,
                backgroundColor: "#fffef5",
                border: "1px solid #e8e8e8",
                borderRadius: "6px",
                padding: "15px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#666", marginBottom: "8px" }}>
                Meses del año completo
              </div>
              <p style={{ fontSize: "0.95em", margin: "0", color: "#555", lineHeight: "1.5" }}>
                Todos los periodos del año <strong>{formik.values.year}</strong> ya están cargados.
                <br />
                Por favor, seleccione otro año para crear un nuevo formulario.
                <br />
                Si desea editar un periodo existente, cierre esta ventana y seleccione el formulario a editar.
              </p>
            </div>
          )}
        </>
      ) : null}
      {/* Botón para habilitar edición de unidades (solo admin/master en modo edición) */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
        {canEditUnits && socialForm ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Button
              type="button"
              color={unitEditEnabled ? "orange" : "grey"}
              size="small"
              icon
              labelPosition="left"
              onClick={() => setUnitEditEnabled(!unitEditEnabled)}
            >
              <Icon name={unitEditEnabled ? "unlock" : "lock"} />
              {unitEditEnabled
                ? (t("disable_unit_edit") || "Deshabilitar edición de unidades")
                : (t("enable_unit_edit") || "Habilitar edición de unidades")
              }
            </Button>
            {unitEditEnabled && (
              <Message warning size="tiny" style={{ margin: 0, padding: "8px 12px" }}>
                <Icon name="warning sign" />
                {t("unit_edit_warning") || "Los cambios de unidad se registrarán en auditoría"}
              </Message>
            )}
          </div>
        ) : <div />}
        {/* <Popup
          content={t("read_invoice_tooltip") || "Leer documento"}
          trigger={
            <Form.Button
              type="button"
              color="teal"
              size="small"
              icon="file alternate"
              loading={invoiceLoading}
              onClick={() => setShowUploadModal(true)}
            />
          }
        /> */}
      </div>
      <Table className="social-form-table" unstackable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="1">{t("code")}</Table.HeaderCell>
            {<Table.HeaderCell width="6">{t("concept")}</Table.HeaderCell>}{" "}
            <Table.HeaderCell width="2">{t("value")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("unit")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("state")}</Table.HeaderCell>
            <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {findActiveFieldByName("days_worked") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.days_worked.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("days_worked")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="days_worked.value"
                  onChange={formik.handleChange}
                  value={formik.values.days_worked.value}
                  error={formik.errors.days_worked?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.days_worked?.unit &&
                    formik.touched.days_worked?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.days_worked.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits("days_worked").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("days_worked.unit", data.value);
                      formik.setFieldTouched("days_worked.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("days_worked.unit", undefined);
                      }
                    }}
                    value={formik.values.days_worked.unit}
                    error={
                      !!formik.errors.days_worked?.unit &&
                      !!formik.touched.days_worked?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.days_worked?.unit &&
                        formik.touched.days_worked?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="days_worked.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("days_worked.approvalStatus", data.value)
                  }
                  value={formik.values.days_worked.approvalStatus}
                  error={formik.errors.days_worked?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.days_worked.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.installation_type.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(t("days_worked"), "days_worked");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"days_worked"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("normal_hours_worked") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.normal_hours_worked.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("normal_hours_worked")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="normal_hours_worked.value"
                  onChange={formik.handleChange}
                  value={formik.values.normal_hours_worked.value}
                  error={formik.errors.normal_hours_worked?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.normal_hours_worked?.unit &&
                    formik.touched.normal_hours_worked?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.normal_hours_worked.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits("normal_hours_worked").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "normal_hours_worked.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "normal_hours_worked.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "normal_hours_worked.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.normal_hours_worked.unit}
                    error={
                      !!formik.errors.normal_hours_worked?.unit &&
                      !!formik.touched.normal_hours_worked?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.normal_hours_worked?.unit &&
                        formik.touched.normal_hours_worked?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="normal_hours_worked.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "normal_hours_worked.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.normal_hours_worked.approvalStatus}
                  error={formik.errors.normal_hours_worked?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.normal_hours_worked.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.normal_hours_worked.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("normal_hours_worked"),
                          "normal_hours_worked"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"normal_hours_worked"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("fifty_percent_overtime") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.fifty_percent_overtime.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("fifty_percent_overtime")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="fifty_percent_overtime.value"
                  onChange={formik.handleChange}
                  value={formik.values.fifty_percent_overtime.value}
                  error={formik.errors.fifty_percent_overtime?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.fifty_percent_overtime?.unit &&
                    formik.touched.fifty_percent_overtime?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.fifty_percent_overtime.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits("fifty_percent_overtime").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "fifty_percent_overtime.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "fifty_percent_overtime.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "fifty_percent_overtime.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.fifty_percent_overtime.unit}
                    error={
                      !!formik.errors.fifty_percent_overtime?.unit &&
                      !!formik.touched.fifty_percent_overtime?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.fifty_percent_overtime?.unit &&
                        formik.touched.fifty_percent_overtime?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="fifty_percent_overtime.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "fifty_percent_overtime.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.fifty_percent_overtime.approvalStatus}
                  error={formik.errors.fifty_percent_overtime?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.fifty_percent_overtime.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.fifty_percent_overtime.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("fifty_percent_overtime"),
                          "fifty_percent_overtime"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"fifty_percent_overtime"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("one_hundred_percent_overtime") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.one_hundred_percent_overtime.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("one_hundred_percent_overtime")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="one_hundred_percent_overtime.value"
                  onChange={formik.handleChange}
                  value={formik.values.one_hundred_percent_overtime.value}
                  error={formik.errors.one_hundred_percent_overtime?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.one_hundred_percent_overtime?.unit &&
                    formik.touched.one_hundred_percent_overtime?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.one_hundred_percent_overtime.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "one_hundred_percent_overtime"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "one_hundred_percent_overtime.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "one_hundred_percent_overtime.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "one_hundred_percent_overtime.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.one_hundred_percent_overtime.unit}
                    error={
                      !!formik.errors.one_hundred_percent_overtime?.unit &&
                      !!formik.touched.one_hundred_percent_overtime?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.one_hundred_percent_overtime?.unit &&
                        formik.touched.one_hundred_percent_overtime?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="one_hundred_percent_overtime.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "one_hundred_percent_overtime.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.one_hundred_percent_overtime.approvalStatus}
                  error={formik.errors.one_hundred_percent_overtime?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.one_hundred_percent_overtime.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.one_hundred_percent_overtime.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("one_hundred_percent_overtime"),
                          "one_hundred_percent_overtime"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"one_hundred_percent_overtime"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("female_production_workers") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.female_production_workers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("female_production_workers")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="female_production_workers.value"
                  onChange={formik.handleChange}
                  value={formik.values.female_production_workers.value}
                  error={formik.errors.female_production_workers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.female_production_workers?.unit &&
                    formik.touched.female_production_workers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.female_production_workers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "female_production_workers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "female_production_workers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "female_production_workers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "female_production_workers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.female_production_workers.unit}
                    error={
                      !!formik.errors.female_production_workers?.unit &&
                      !!formik.touched.female_production_workers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.female_production_workers?.unit &&
                        formik.touched.female_production_workers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="female_production_workers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "female_production_workers.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.female_production_workers.approvalStatus}
                  error={formik.errors.female_production_workers?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.female_production_workers.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.female_production_workers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("female_production_workers"),
                          "female_production_workers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"female_production_workers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("male_production_workers") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.male_production_workers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("male_production_workers")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="male_production_workers.value"
                  onChange={formik.handleChange}
                  value={formik.values.male_production_workers.value}
                  error={formik.errors.male_production_workers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.male_production_workers?.unit &&
                    formik.touched.male_production_workers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.male_production_workers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "male_production_workers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "male_production_workers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "male_production_workers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "male_production_workers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.male_production_workers.unit}
                    error={
                      !!formik.errors.male_production_workers?.unit &&
                      !!formik.touched.male_production_workers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.male_production_workers?.unit &&
                        formik.touched.male_production_workers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="male_production_workers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "male_production_workers.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.male_production_workers.approvalStatus}
                  error={formik.errors.male_production_workers?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.male_production_workers.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.male_production_workers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("male_production_workers"),
                          "male_production_workers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"male_production_workers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("other_gender_production_workers") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.other_gender_production_workers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  Cantidad de trabajadores administrativos permanentes
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="other_gender_production_workers.value"
                  onChange={formik.handleChange}
                  value={formik.values.other_gender_production_workers.value}
                  error={formik.errors.other_gender_production_workers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.other_gender_production_workers?.unit &&
                    formik.touched.other_gender_production_workers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.other_gender_production_workers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "other_gender_production_workers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "other_gender_production_workers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "other_gender_production_workers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "other_gender_production_workers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.other_gender_production_workers.unit}
                    error={
                      !!formik.errors.other_gender_production_workers?.unit &&
                      !!formik.touched.other_gender_production_workers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.other_gender_production_workers?.unit &&
                        formik.touched.other_gender_production_workers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="other_gender_production_workers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "other_gender_production_workers.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.other_gender_production_workers.approvalStatus
                  }
                  error={
                    formik.errors.other_gender_production_workers?.approvalStatus
                  }
                     disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.other_gender_production_workers.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.other_gender_production_workers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("other_gender_production_workers"),
                          "other_gender_production_workers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"other_gender_production_workers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("female_administrative_workers") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.female_administrative_workers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("female_administrative_workers")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="female_administrative_workers.value"
                  onChange={formik.handleChange}
                  value={formik.values.female_administrative_workers.value}
                  error={formik.errors.female_administrative_workers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.female_administrative_workers?.unit &&
                    formik.touched.female_administrative_workers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.female_administrative_workers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "female_administrative_workers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "female_administrative_workers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "female_administrative_workers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "female_administrative_workers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.female_administrative_workers.unit}
                    error={
                      !!formik.errors.female_administrative_workers?.unit &&
                      !!formik.touched.female_administrative_workers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.female_administrative_workers?.unit &&
                        formik.touched.female_administrative_workers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="female_administrative_workers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "female_administrative_workers.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.female_administrative_workers.approvalStatus}
                  error={
                    formik.errors.female_administrative_workers?.approvalStatus
                  }
                   disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.female_administrative_workers.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.female_administrative_workers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("female_administrative_workers"),
                          "female_administrative_workers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"female_administrative_workers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("male_administrative_workers") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.male_administrative_workers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("male_administrative_workers")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="male_administrative_workers.value"
                  onChange={formik.handleChange}
                  value={formik.values.male_administrative_workers.value}
                  error={formik.errors.male_administrative_workers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.male_administrative_workers?.unit &&
                    formik.touched.male_administrative_workers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.male_administrative_workers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "male_administrative_workers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "male_administrative_workers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "male_administrative_workers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "male_administrative_workers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.male_administrative_workers.unit}
                    error={
                      !!formik.errors.male_administrative_workers?.unit &&
                      !!formik.touched.male_administrative_workers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.male_administrative_workers?.unit &&
                        formik.touched.male_administrative_workers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="male_administrative_workers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "male_administrative_workers.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.male_administrative_workers.approvalStatus}
                  error={formik.errors.male_administrative_workers?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.male_administrative_workers.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.male_administrative_workers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("male_administrative_workers"),
                          "male_administrative_workers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"male_administrative_workers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("administrative_workers_other_genders") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.administrative_workers_other_genders.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("administrative_workers_other_genders")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="administrative_workers_other_genders.value"
                  onChange={formik.handleChange}
                  value={
                    formik.values.administrative_workers_other_genders.value
                  }
                  error={
                    formik.errors.administrative_workers_other_genders?.value
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.administrative_workers_other_genders?.unit &&
                    formik.touched.administrative_workers_other_genders
                      ?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {
                          formik.errors.administrative_workers_other_genders
                            .unit
                        }
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "administrative_workers_other_genders"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "administrative_workers_other_genders.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "administrative_workers_other_genders.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "administrative_workers_other_genders.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.administrative_workers_other_genders.unit
                    }
                    error={
                      !!formik.errors.administrative_workers_other_genders
                        ?.unit &&
                      !!formik.touched.administrative_workers_other_genders
                        ?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.administrative_workers_other_genders
                          ?.unit &&
                        formik.touched.administrative_workers_other_genders
                          ?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="administrative_workers_other_genders.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "administrative_workers_other_genders.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.administrative_workers_other_genders
                      .approvalStatus
                  }
                  error={
                    formik.errors.administrative_workers_other_genders
                      ?.approvalStatus
                  }
                                       disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.administrative_workers_other_genders.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.administrative_workers_other_genders.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("administrative_workers_other_genders"),
                          "administrative_workers_other_genders"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"administrative_workers_other_genders"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("female_temporary_workers") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.female_temporary_workers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("female_temporary_workers")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="female_temporary_workers.value"
                  onChange={formik.handleChange}
                  value={formik.values.female_temporary_workers.value}
                  error={formik.errors.female_temporary_workers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.female_temporary_workers?.unit &&
                    formik.touched.female_temporary_workers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.female_temporary_workers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "female_temporary_workers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "female_temporary_workers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "female_temporary_workers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "female_temporary_workers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.female_temporary_workers.unit}
                    error={
                      !!formik.errors.female_temporary_workers?.unit &&
                      !!formik.touched.female_temporary_workers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.female_temporary_workers?.unit &&
                        formik.touched.female_temporary_workers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="female_temporary_workers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "female_temporary_workers.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.female_temporary_workers.approvalStatus}
                  error={formik.errors.female_temporary_workers?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.female_temporary_workers.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.female_temporary_workers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("female_temporary_workers"),
                          "female_temporary_workers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"female_temporary_workers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("male_temporary_workers") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.male_temporary_workers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("male_temporary_workers")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="male_temporary_workers.value"
                  onChange={formik.handleChange}
                  value={formik.values.male_temporary_workers.value}
                  error={formik.errors.male_temporary_workers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.male_temporary_workers?.unit &&
                    formik.touched.male_temporary_workers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.male_temporary_workers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits("male_temporary_workers").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "male_temporary_workers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "male_temporary_workers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "male_temporary_workers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.male_temporary_workers.unit}
                    error={
                      !!formik.errors.male_temporary_workers?.unit &&
                      !!formik.touched.male_temporary_workers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.male_temporary_workers?.unit &&
                        formik.touched.male_temporary_workers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="male_temporary_workers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "male_temporary_workers.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.male_temporary_workers.approvalStatus}
                  error={formik.errors.male_temporary_workers?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.male_temporary_workers.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.male_temporary_workers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("male_temporary_workers"),
                          "male_temporary_workers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"male_temporary_workers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("temporary_workers_other_genders") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.temporary_workers_other_genders.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("temporary_workers_other_genders")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="temporary_workers_other_genders.value"
                  onChange={formik.handleChange}
                  value={formik.values.temporary_workers_other_genders.value}
                  error={formik.errors.temporary_workers_other_genders?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.temporary_workers_other_genders?.unit &&
                    formik.touched.temporary_workers_other_genders?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.temporary_workers_other_genders.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "temporary_workers_other_genders"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "temporary_workers_other_genders.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "temporary_workers_other_genders.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "temporary_workers_other_genders.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.temporary_workers_other_genders.unit}
                    error={
                      !!formik.errors.temporary_workers_other_genders?.unit &&
                      !!formik.touched.temporary_workers_other_genders?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.temporary_workers_other_genders?.unit &&
                        formik.touched.temporary_workers_other_genders?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="temporary_workers_other_genders.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "temporary_workers_other_genders.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.temporary_workers_other_genders.approvalStatus
                  }
                  error={
                    formik.errors.temporary_workers_other_genders?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.temporary_workers_other_genders.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.temporary_workers_other_genders.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("temporary_workers_other_genders"),
                          "temporary_workers_other_genders"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"temporary_workers_other_genders"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("female_workers_leadership_positions") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.female_workers_leadership_positions.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("female_workers_leadership_positions")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="female_workers_leadership_positions.value"
                  onChange={formik.handleChange}
                  value={
                    formik.values.female_workers_leadership_positions.value
                  }
                  error={
                    formik.errors.female_workers_leadership_positions?.value
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.female_workers_leadership_positions?.unit &&
                    formik.touched.female_workers_leadership_positions
                      ?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.female_workers_leadership_positions.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "female_workers_leadership_positions"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "female_workers_leadership_positions.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "female_workers_leadership_positions.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "female_workers_leadership_positions.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.female_workers_leadership_positions.unit
                    }
                    error={
                      !!formik.errors.female_workers_leadership_positions
                        ?.unit &&
                      !!formik.touched.female_workers_leadership_positions?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.female_workers_leadership_positions
                          ?.unit &&
                        formik.touched.female_workers_leadership_positions?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="female_workers_leadership_positions.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "female_workers_leadership_positions.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.female_workers_leadership_positions.approvalStatus
                  }
                  error={
                    formik.errors.female_workers_leadership_positions
                      ?.approvalStatus
                  }
                                    disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.female_workers_leadership_positions.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.female_workers_leadership_positions.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("female_workers_leadership_positions"),
                          "female_workers_leadership_positions"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"female_workers_leadership_positions"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("male_workers_leadership_positions") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.male_workers_leadership_positions.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("male_workers_leadership_positions")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="male_workers_leadership_positions.value"
                  onChange={formik.handleChange}
                  value={formik.values.male_workers_leadership_positions.value}
                  error={formik.errors.male_workers_leadership_positions?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.male_workers_leadership_positions?.unit &&
                    formik.touched.male_workers_leadership_positions?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.male_workers_leadership_positions.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "male_workers_leadership_positions"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "male_workers_leadership_positions.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "male_workers_leadership_positions.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "male_workers_leadership_positions.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.male_workers_leadership_positions.unit}
                    error={
                      !!formik.errors.male_workers_leadership_positions?.unit &&
                      !!formik.touched.male_workers_leadership_positions?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.male_workers_leadership_positions?.unit &&
                        formik.touched.male_workers_leadership_positions?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="male_workers_leadership_positions.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "male_workers_leadership_positions.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.male_workers_leadership_positions.approvalStatus
                  }
                  error={
                    formik.errors.male_workers_leadership_positions?.approvalStatus
                  }
                    disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.male_workers_leadership_positions.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.male_workers_leadership_positions.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("male_workers_leadership_positions"),
                          "male_workers_leadership_positions"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"male_workers_leadership_positions"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("workers_under_cct") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.workers_under_cct.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("workers_under_cct")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="workers_under_cct.value"
                  onChange={formik.handleChange}
                  value={formik.values.workers_under_cct.value}
                  error={formik.errors.workers_under_cct?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.workers_under_cct?.unit &&
                    formik.touched.workers_under_cct?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.workers_under_cct.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits("workers_under_cct").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "workers_under_cct.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "workers_under_cct.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "workers_under_cct.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.workers_under_cct.unit}
                    error={
                      !!formik.errors.workers_under_cct?.unit &&
                      !!formik.touched.workers_under_cct?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.workers_under_cct?.unit &&
                        formik.touched.workers_under_cct?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="workers_under_cct.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "workers_under_cct.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.workers_under_cct.approvalStatus}
                  error={formik.errors.workers_under_cct?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.workers_under_cct.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.workers_under_cct.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("workers_under_cct"),
                          "workers_under_cct"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"workers_under_cct"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("work_accidents_with_sick_days") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.work_accidents_with_sick_days.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("work_accidents_with_sick_days")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="work_accidents_with_sick_days.value"
                  onChange={formik.handleChange}
                  value={formik.values.work_accidents_with_sick_days.value}
                  error={formik.errors.work_accidents_with_sick_days?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.work_accidents_with_sick_days?.unit &&
                    formik.touched.work_accidents_with_sick_days?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.work_accidents_with_sick_days.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "work_accidents_with_sick_days"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "work_accidents_with_sick_days.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "work_accidents_with_sick_days.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "work_accidents_with_sick_days.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.work_accidents_with_sick_days.unit}
                    error={
                      !!formik.errors.work_accidents_with_sick_days?.unit &&
                      !!formik.touched.work_accidents_with_sick_days?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.work_accidents_with_sick_days?.unit &&
                        formik.touched.work_accidents_with_sick_days?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="work_accidents_with_sick_days.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "work_accidents_with_sick_days.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.work_accidents_with_sick_days.approvalStatus}
                  error={
                    formik.errors.work_accidents_with_sick_days?.approvalStatus
                  }
                                      disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.work_accidents_with_sick_days.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.work_accidents_with_sick_days.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("work_accidents_with_sick_days"),
                          "work_accidents_with_sick_days"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"work_accidents_with_sick_days"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("in_itine_accidents") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.in_itine_accidents.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("in_itine_accidents")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="in_itine_accidents.value"
                  onChange={formik.handleChange}
                  value={formik.values.in_itine_accidents.value}
                  error={formik.errors.in_itine_accident?.values}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.in_itine_accidents?.unit &&
                    formik.touched.in_itine_accidents?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.in_itine_accidents.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits("in_itine_accidents").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "in_itine_accidents.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "in_itine_accidents.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "in_itine_accidents.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.in_itine_accidents.unit}
                    error={
                      !!formik.errors.in_itine_accidents?.unit &&
                      !!formik.touched.in_itine_accidents?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.in_itine_accidents?.unit &&
                        formik.touched.in_itine_accidents?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="in_itine_accidents.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "in_itine_accidents.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.in_itine_accidents.approvalStatus}
                  error={formik.errors.in_itine_accidents?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.in_itine_accidents.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.in_itine_accidents.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("in_itine_accidents"),
                          "in_itine_accidents"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"in_itine_accidents"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("first_aid_without_sick_days") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.first_aid_without_sick_days.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("first_aid_without_sick_days")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="first_aid_without_sick_days.value"
                  onChange={formik.handleChange}
                  value={formik.values.first_aid_without_sick_days.value}
                  error={formik.errors.first_aid_without_sick_days?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.first_aid_without_sick_days?.unit &&
                    formik.touched.first_aid_without_sick_days?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.first_aid_without_sick_days.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "first_aid_without_sick_days"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "first_aid_without_sick_days.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "first_aid_without_sick_days.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "first_aid_without_sick_days.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.first_aid_without_sick_days.unit}
                    error={
                      !!formik.errors.first_aid_without_sick_days?.unit &&
                      !!formik.touched.first_aid_without_sick_days?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.first_aid_without_sick_days?.unit &&
                        formik.touched.first_aid_without_sick_days?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="first_aid_without_sick_days.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "first_aid_without_sick_days.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.first_aid_without_sick_days.approvalStatus}
                  error={formik.errors.first_aid_without_sick_days?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.first_aid_without_sick_days.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.first_aid_without_sick_days.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("first_aid_without_sick_days"),
                          "first_aid_without_sick_days"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"first_aid_without_sick_days"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hours_training_social_issues") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.hours_training_social_issues.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("hours_training_social_issues")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="hours_training_social_issues.value"
                  onChange={formik.handleChange}
                  value={formik.values.hours_training_social_issues.value}
                  error={formik.errors.hours_training_social_issues?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hours_training_social_issues?.unit &&
                    formik.touched.hours_training_social_issues?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hours_training_social_issues.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "hours_training_social_issues"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hours_training_social_issues.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hours_training_social_issues.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hours_training_social_issues.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hours_training_social_issues.unit}
                    error={
                      !!formik.errors.hours_training_social_issues?.unit &&
                      !!formik.touched.hours_training_social_issues?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hours_training_social_issues?.unit &&
                        formik.touched.hours_training_social_issues?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="hours_training_social_issues.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hours_training_social_issues.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hours_training_social_issues.approvalStatus}
                  error={formik.errors.hours_training_social_issues?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.hours_training_social_issues.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.hours_training_social_issues.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("hours_training_social_issues"),
                          "hours_training_social_issues"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hours_training_social_issues"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hours_training_hys") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.hours_training_hys.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hours_training_hys")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="hours_training_hys.value"
                  onChange={formik.handleChange}
                  value={formik.values.hours_training_hys.value}
                  error={formik.errors.hours_training_hys?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hours_training_hys?.unit &&
                    formik.touched.hours_training_hys?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hours_training_hys.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits("hours_training_hys").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hours_training_hys.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hours_training_hys.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hours_training_hys.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hours_training_hys.unit}
                    error={
                      !!formik.errors.hours_training_hys?.unit &&
                      !!formik.touched.hours_training_hys?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hours_training_hys?.unit &&
                        formik.touched.hours_training_hys?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="hours_training_hys.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hours_training_hys.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hours_training_hys.approvalStatus}
                  error={formik.errors.hours_training_hys?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.hours_training_hys.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.hours_training_social_issues.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("hours_training_hys"),
                          "hours_training_hys"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hours_training_hys"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hours_environmental_awareness_training") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.hours_environmental_awareness_training.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("hours_environmental_awareness_training")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="hours_environmental_awareness_training.value"
                  onChange={formik.handleChange}
                  value={
                    formik.values.hours_environmental_awareness_training.value
                  }
                  error={
                    formik.errors.hours_environmental_awareness_training?.value
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hours_environmental_awareness_training?.unit &&
                    formik.touched.hours_environmental_awareness_training
                      ?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {
                          formik.errors.hours_environmental_awareness_training
                            .unit
                        }
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "hours_environmental_awareness_training"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hours_environmental_awareness_training.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hours_environmental_awareness_training.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hours_environmental_awareness_training.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.hours_environmental_awareness_training.unit
                    }
                    error={
                      !!formik.errors.hours_environmental_awareness_training
                        ?.unit &&
                      !!formik.touched.hours_environmental_awareness_training
                        ?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hours_environmental_awareness_training
                          ?.unit &&
                        formik.touched.hours_environmental_awareness_training
                          ?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="hours_environmental_awareness_training.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hours_environmental_awareness_training.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.hours_environmental_awareness_training
                      .approvalStatus
                  }
                  error={
                    formik.errors.hours_environmental_awareness_training
                      ?.approvalStatus
                  }
                                                        disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.hours_environmental_awareness_training.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.hours_training_social_issues.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("hours_environmental_awareness_training"),
                          "hours_environmental_awareness_training"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hours_environmental_awareness_training"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("volunteer_hours") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.volunteer_hours.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("volunteer_hours")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="volunteer_hours.value"
                  onChange={formik.handleChange}
                  value={formik.values.volunteer_hours.value}
                  error={formik.errors.volunteer_hours?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.volunteer_hours?.unit &&
                    formik.touched.volunteer_hours?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.volunteer_hours.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits("volunteer_hours").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("volunteer_hours.unit", data.value);
                      formik.setFieldTouched(
                        "volunteer_hours.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("volunteer_hours.unit", undefined);
                      }
                    }}
                    value={formik.values.volunteer_hours.unit}
                    error={
                      !!formik.errors.volunteer_hours?.unit &&
                      !!formik.touched.volunteer_hours?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.volunteer_hours?.unit &&
                        formik.touched.volunteer_hours?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="volunteer_hours.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "volunteer_hours.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.volunteer_hours.approvalStatus}
                  error={formik.errors.volunteer_hours?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.volunteer_hours.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.hours_training_social_issues.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("volunteer_hours"),
                          "volunteer_hours"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"volunteer_hours"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("complaints_or_suggestions_received") ? (
            <Table.Row>
              <Table.Cell>
                {" "}
                <label className="label">
                  {formik.values.complaints_or_suggestions_received.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("complaints_or_suggestions_received")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                onFocus={handleFocusNumberInput}
                  name="complaints_or_suggestions_received.value"
                  onChange={formik.handleChange}
                  value={formik.values.complaints_or_suggestions_received.value}
                  error={
                    formik.errors.complaints_or_suggestions_received?.value
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.complaints_or_suggestions_received?.unit &&
                    formik.touched.complaints_or_suggestions_received?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.complaints_or_suggestions_received.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineSocialUnits(
                      "complaints_or_suggestions_received"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "complaints_or_suggestions_received.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "complaints_or_suggestions_received.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "complaints_or_suggestions_received.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.complaints_or_suggestions_received.unit
                    }
                    error={
                      !!formik.errors.complaints_or_suggestions_received
                        ?.unit &&
                      !!formik.touched.complaints_or_suggestions_received?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.complaints_or_suggestions_received
                          ?.unit &&
                        formik.touched.complaints_or_suggestions_received?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="complaints_or_suggestions_received.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "complaints_or_suggestions_received.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.complaints_or_suggestions_received.approvalStatus
                  }
                  error={
                    formik.errors.complaints_or_suggestions_received?.approvalStatus
                  }
                   disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.complaints_or_suggestions_received.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.hours_training_social_issues.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSocial(
                          t("complaints_or_suggestions_received"),
                          "complaints_or_suggestions_received"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"complaints_or_suggestions_received"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
        </Table.Body>

        {/* <TableFooter fullWidth>
      <TableRow>
        <TableHeaderCell />
        <TableHeaderCell colSpan='4'>
          <Button
            floated='right'
            labelPosition='left'
            secundary
            size='small'
          > Aprobar todos
          </Button>
        </TableHeaderCell>
      </TableRow>
    </TableFooter> */}
      </Table>

      <ToastContainer
        position="bottom-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

           <BasicModal
              show={showModal}
              onClose={() => setShowModal(false)}       // cerrar desde aquí
              title={titleModal}
              size="tiny"
              closeOnDimmerClick={false}             // evita cierre al hacer clic fuera
              closeOnEscape={false}                   // opcional
            >
              
              <div onClick={(e) => e.stopPropagation()}>
        <Comments
          formik={formik}
          fieldName={fieldName}
          onClose={() => setShowModal(false)}
          onReload={onReload}
          socialForm={socialForm}
          user={user}
          t={t}
        /></div>
      </BasicModal>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "0.5rem",
          marginRight: 20,
          marginTop: 20,
          alignItems: "center",
        }}
      >
        <Button
          type="submit"
          primary
          size="large"
          loading={formik.isSubmitting}
          content={!socialForm ? t("save") : t("update")}
        />

        <Button
          type="button"
          color="red"
          secondary
          size="large"
          onClick={() => {
            onClose ? onClose() : goBack();
          }}
        >
          {t("cancel")}
        </Button>
      </div>

      <Modal open={showUploadModal} onClose={() => !invoiceLoading && setShowUploadModal(false)} size="small" closeOnDimmerClick={!invoiceLoading} className="invoice-reader-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("read_invoice") || "Leer documento"}</Modal.Header>
        <Modal.Content>
          <InvoiceDropzone onFiles={processInvoiceFiles} loading={invoiceLoading} t={t} inputRef={invoiceInputRef} onInputChange={handleInvoiceFileChange} />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowUploadModal(false)} disabled={invoiceLoading}>{t("cancel")}</Button>
        </Modal.Actions>
      </Modal>

      <Modal open={showInvoiceModal} onClose={() => setShowInvoiceModal(false)} size="small" closeOnDimmerClick={false} className="invoice-preview-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("extracted_invoice_data") || "Datos extraídos"}</Modal.Header>
        <Modal.Content>
          {invoiceResults.length > 0 && (
            <div className="invoice-reader-preview">
              <Message info size="small" style={{ marginBottom: "1rem" }}>
                <Icon name="info circle" />
                {t("review_before_applying") || "Revisá los datos antes de aplicar. Hacé clic en Aplicar en la fila deseada."}
              </Message>
              <Table size="small" compact>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>{t("file") || "Archivo"}</Table.HeaderCell>
                    <Table.HeaderCell>{t("period") || "Período"}</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {invoiceResults.map((r, i) => (
                    <Table.Row key={i} negative={!!r.error}>
                      <Table.Cell>
                        <Icon name="paperclip" />
                        <span style={{ fontSize: "0.85em" }}>{r.filename}</span>
                        {r.format && <span style={{ marginLeft: "0.4rem", background: "#e8f4fd", color: "#1a6ba0", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600, textTransform: "uppercase" }}>{r.format}</span>}
                      </Table.Cell>
                      <Table.Cell>{r.error ? <span style={{color:"red"}}>{r.error}</span> : r.period ? <strong>{r.period}/{r.year}</strong> : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}</Table.Cell>
                      <Table.Cell>
                        {!r.error && (
                          <Button size="mini" color="teal" onClick={() => handleApplyInvoiceData(r)}>
                            <Icon name="check" /> {t("apply") || "Aplicar"}
                          </Button>
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowInvoiceModal(false)}><Icon name="close" /> {t("cancel")}</Button>
        </Modal.Actions>
      </Modal>
    </Form>
  );
}

function InvoiceDropzone({ onFiles, loading, t, inputRef, onInputChange }) {
  const [isDragOver, setIsDragOver] = useState(false);
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [], "image/*": [], "text/csv": [], "application/vnd.ms-excel": [], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], "text/plain": [] },
    multiple: true, disabled: loading, noClick: true, noKeyboard: true,
    onDrop: (accepted) => { if (accepted.length > 0) onFiles(accepted); },
    onDragEnter: () => setIsDragOver(true),
    onDragLeave: () => setIsDragOver(false),
    onDropAccepted: () => setIsDragOver(false),
    onDropRejected: () => setIsDragOver(false),
  });
  return (
    <div {...getRootProps()} style={{ border: `2px dashed ${isDragOver ? "#648EBC" : "#b0c4de"}`, borderRadius: "12px", padding: "2.5rem 1.5rem", minHeight: "260px", textAlign: "center", cursor: loading ? "not-allowed" : "pointer", background: isDragOver ? "#f0f6ff" : "#fafafa", transition: "all 0.2s ease", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1rem" }}>
      <input {...getInputProps()} />
      <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.txt" multiple style={{ display: "none" }} onChange={onInputChange} />
      {loading ? (
        <><img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="sustemia" className="invoice-dropzone-spinner" /><p style={{ color: "#648EBC", fontWeight: 600 }}>{t("processing")}</p></>
      ) : (
        <><Icon name="cloud upload" size="huge" color="blue" style={{ margin: 0 }} />
          <p style={{ margin: 0, fontSize: "1rem", fontWeight: 500, color: "#333" }}>{t("drag_drop_files")}</p>
          <p style={{ margin: 0, color: "#888", fontSize: "0.85rem" }}>o</p>
          <Button type="button" primary onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}><Icon name="folder open outline" />{t("select_files")}</Button>
          <p style={{ margin: 0, color: "#aaa", fontSize: "0.75rem" }}>{t("supported_formats")}</p>
        </>
      )}
    </div>
  );
}

function Comments({ formik, user, fieldName, onClose, t }) {
  const [comment, setComment] = useState("");

  const handleAddComment = () => {
    if (comment.trim().length > 0) {
      const reviews = [...(formik.values[fieldName].reviews || [])];

      reviews.push({
        comments: comment.trim(),
        date: new Date(),
        reviewer_user: user ? user._id : null,
      });

      formik.setFieldValue(`${fieldName}.reviews`, reviews);
      setComment("");
    }
  };

  const handleSaveComment = (id, editedContent) => {
    const reviews = [...formik.values[fieldName].reviews];
    reviews[id] = {
      ...reviews[id],
      comments: editedContent.trim(),
      date: new Date(),
    };
    formik.setFieldValue(`${fieldName}.reviews`, reviews);
  };

  const reviews = formik.values[fieldName]?.reviews || [];

  return (
    <CommentGroup minimal>
      <Header as="h4" dividing>{t("comments")}</Header>
      {reviews.map((review, index) => (
    
        <React.Fragment key={index}>
          <EditableComment
            id={index}
            author={
              review.reviewer_user
                ? review.reviewer_user === user._id
                  ? `${user.firstname} ${user.lastname}`
                  : `${review.reviewer_user.firstname} ${review.reviewer_user.lastname}`
                : ""
            }
            date={formatDateHourCompleted(review.date)}
            content={review.comments}
            onSave={handleSaveComment}
            active={review.reviewer_user === user._id}
            t={t}
          />
          <Divider fitted />    {console.log(review)}
        </React.Fragment>
      ))}


      {/* ✨ Form con preventDefault para evitar submit accidental */}
      <Form reply className="comments-reply-form" onSubmit={(e) => e.preventDefault()}>
        <Form.TextArea
          placeholder={t("write_a_comment")}
          rows={3}
          style={{ minHeight: 100 }}
          onChange={(_, data) => setComment(data.value)}
          value={comment}
        />

        <div style={{ display: "flex", gap: "1em", marginTop: "1em", justifyContent: "center" }}>
          <Button
            type="button" // importante para no disparar submit
            content="Añadir"
            primary
            size="small"
            style={{ minWidth: 100 }}
            onClick={handleAddComment}
          />
          <Button
            type="button" // importante para no disparar submit
            content={t("close")}
            secondary
            size="small"
            style={{ minWidth: 100 }}
            onClick={onClose}
          />
        </div>
      </Form>
    </CommentGroup>
  );
}
function EditableComment({ id, author, date, content, onSave, active, t }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);

  const handleChange = (e) => setEditedContent(e.target.value);
  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setEditedContent(content);
    setIsEditing(false);
  };
  const handleSave = () => {
    if (editedContent.trim()) {
      onSave(id, editedContent);
      setIsEditing(false);
    }
  };

  const initials = author
    ? author.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <div style={{
      display: 'flex',
      gap: '10px',
      padding: '10px 12px',
      borderRadius: '10px',
      backgroundColor: '#f4f6f9',
      marginBottom: '8px',
    }}>
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#648EBC',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
      }}>
        {initials}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontWeight: '700', fontSize: '13px', color: '#1A1C40' }}>{author}</span>
          <span style={{ fontSize: '11px', color: '#999' }}>{date}</span>
        </div>
        {isEditing ? (
          <Form reply>
            <Form.TextArea value={editedContent} onChange={handleChange} rows={3} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem", justifyContent: "center" }}>
              <Button type="button" icon="check" circular primary className="btn-comment-edit-action" onClick={handleSave} />
              <Button type="button" icon="times" circular secondary className="btn-comment-edit-action" onClick={handleCancel} />
            </div>
          </Form>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#333', wordBreak: 'break-word' }}>{content}</p>
            {active && (
              <Icon
                name="pencil"
                size="small"
                style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0, marginTop: '2px' }}
                onClick={handleEdit}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function FileViewer(props) {
  const { fileName, fileUniqueName, handleRemove, t } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (fileName) {
      setFileUrl(fileName); // Construye la URL del archivo
      (async () => {
        try {
          const response = await socialFormController.getFileApi(
            fileUniqueName
          );
          setFileUrl(response); // Construye la URL del archivo
          //console.log(setFileUrl);
          //setMessage(response.message);
        } catch (error) {
          //setMessage('Error al elimianr el archivo');
        }
      })();
    }
  }, [fileName]);

  const handleOpenPreview = (event) => {
    event.preventDefault();
    setPreviewOpen(true);
  };

  const handleClosePreview = (event) => {
    event.preventDefault(); // Previene el comportamiento predeterminado
    setPreviewOpen(false);
  };

  return (
    <>
      <List.Content floated="left">{fileName}</List.Content>
      <List.Content floated="right">
        {" "}
        <Button
          color="red"
          onClick={() => handleRemove(fileUniqueName)}
          icon="trash alternate"
        />
      </List.Content>
      {/* //<Button onClick={handleOpenPreview}> {fileName}</Button> */}
      <List.Content floated="right">
        <Modal
          onClose={handleClosePreview}
          onOpen={handleOpenPreview}
          open={previewOpen}
          trigger={
            <Button primary icon>
              <Icon name="eye" />
            </Button>
          }
        >
          <ModalHeader>{fileName}</ModalHeader>
          <ModalContent>
            {fileName &&
              (fileName.endsWith(".jpg") ||
                fileName.endsWith(".png") ||
                fileName.endsWith(".jpeg")) && (
                <Image
                  src={fileUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%" }}
                />
              )}
            {fileName && fileName.endsWith(".pdf") && (
              <iframe
                src={fileUrl}
                title={t("preview")}
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </ModalContent>
          <ModalActions>
            {/* <Button color="red" onClick={() => handleRemove(fileName)}>
            <Icon disabled name="trash alternate" /> Eliminar
          </Button> */}
            <Button color="black" onClick={handleClosePreview}>
              <Icon disabled name="close" />
              {t("close")}
            </Button>
          </ModalActions>
        </Modal>
      </List.Content>
    </>
  );
}

function FileUpload(props) {
  const { accessToken, data, field, newFiles, setNewFiles, t } = props;
  const [files, setFiles] = useState([]);
  const [filesView, setFilesView] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // Para controlar el estado del modal

  useEffect(() => {
    if (data.values[field].files) {
      setFilesView(data.values[field].files); // Construye la URL del archivo
    }
  }, [data]);

  const handleButtonClick = (event) => {
    event.preventDefault(); // Evita que el formulario se envíe
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.onchange = handleFileChange;
    input.click();
  };

  // Maneja el cambio cuando se seleccionan archivos
  const handleFileChange = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe
    const selectedFiles = e.target.files;
    setNewFiles({ ...newFiles, [field]: Array.from(selectedFiles) });
    //data.setFieldValue(`${field}.files`,Array.from(selectedFiles))
    setFiles([...selectedFiles]);
  };

  // Función para cerrar el modal
  const closeModal = (event) => {
    event.preventDefault();
    setOpenModal(!openModal);
  };

  const handleRemoveFile = async (file) => {
    try {
      const updatedFiles = filesView.filter((f) => f.uniqueName !== file);
      setFilesView(updatedFiles);
      const response = await socialFormController.deleteFileApi(
        accessToken,
        file
      );
      //setMessage(response.message);
      removeFile(updatedFiles);
    } catch (error) {
      // setMessage('Error al elimianr el archivo');
    }
  };

  const removeFile = async (updatedFiles) => {
    data.setFieldValue(`${field}.files`, updatedFiles);
  };

  return (
    <>
      {/* Input para seleccionar los archivos */}
      <Popup
        content={t("upload_file")}
        trigger={
          <Button
            default
            onClick={handleButtonClick}
            style={{ marginTop: "10px" }}
            color={files.length > 0 ? "green" : "grey"}
          >
            <img src={vector71Icon} alt="upload" style={{ width: 14, height: 14, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />
      {/* Mensajes de éxito o error */}
      {successMessage && (
        <Message success>
          <Message.Header>Éxito</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

      <Popup
        content={t("view_file")}
        trigger={
          <Button
            primary
            onClick={closeModal}
            style={{ marginTop: "10px" }}
          >
            <img src={viewIcon} alt="view" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />
      {/* Modal para mostrar los archivos subidos */}
      <BasicModal show={openModal} close={closeModal} title="Archivos subidos" size="tiny">
          <List divided>
            {filesView.length > 0 && (
              <>
                <Header as="h4">Archivos existentes</Header>
                {filesView.map((filePath, index) => (
                  <List.Item key={index}>
                    <FileViewer
                      fileName={filePath.name}
                      fileUniqueName={filePath.uniqueName}
                      handleRemove={handleRemoveFile}
                      t={t}
                    />
                  </List.Item>
                ))}
              </>
            )}
            {newFiles[field] && newFiles[field].length > 0 && (
              <>
                <Header as="h4">Archivos nuevos (se guardarán al enviar)</Header>
                {newFiles[field].map((file, index) => (
                  <List.Item key={`new-${index}`}>
                    <List.Content floated="left">{file.name}</List.Content>
                    <List.Content floated="right">
                      <Button
                        color="blue"
                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                        icon="eye"
                      />
                      <Button
                        color="red"
                        onClick={() => {
                          const updatedNewFiles = newFiles[field].filter((_, i) => i !== index);
                          setNewFiles({ ...newFiles, [field]: updatedNewFiles });
                        }}
                        icon="trash alternate"
                      />
                    </List.Content>
                  </List.Item>
                ))}
              </>
            )}
            {filesView.length === 0 && (!newFiles[field] || newFiles[field].length === 0) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5em",
                  color: "#9e9e9e",
                  padding: "2em 0",
                }}
              >
                <Icon name="file outline" size="big" />
                <span>No se encontraron archivos subidos.</span>
              </div>
            )}
          </List>
          <div className="view-files-actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5em' }}>
            <Button secondary size="small" style={{ minWidth: 100 }} onClick={closeModal}>{t("close")}</Button>
          </div>
      </BasicModal>
    </>
  );
}
